function TabelaContasCorrentes({ dados }) {
  if (!dados || dados.length === 0) {
    return (
      <div className="sem-dados">
        <p>Nenhuma conta corrente encontrada sem DFE emitido.</p>
      </div>
    );
  }

  return (
    <div className="tabela-container">
      <table className="tabela-dfes-detalhes">
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Orçamento</th>
            <th>Parcela</th>
            <th>Valor</th>
            <th>Data Pagamento</th>
            <th>Método</th>
            <th>DFE em Falta</th>
          </tr>
        </thead>
        <tbody>
          {dados.map((contaCorrente) => {
            // ✅ PROTEÇÃO: Normalizar contas para array
            const contas = Array.isArray(contaCorrente.contas)
              ? contaCorrente.contas
              : [contaCorrente.contas];

            return contas.map((conta) => {
              // ✅ PROTEÇÃO: Normalizar parcelas para array
              const parcelas = Array.isArray(conta.parcelas)
                ? conta.parcelas
                : [conta.parcelas];

              return parcelas.map((parcela, idx) => (
                <tr key={`${conta._id}-${idx}`}>
                  <td>
                    {contaCorrente.cliente?._id ? (
                      <a
                        href={`/clientes/${contaCorrente.cliente._id}`}
                        className="link-cliente"
                      >
                        {contaCorrente.cliente.nome}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td>
                    {conta.orcamento?.codigo || "N/A"}
                    {conta.orcamento?.beneficio &&
                      ` - ${conta.orcamento.beneficio}`}
                  </td>
                  <td>{parcela.nrParcela || idx + 1}</td>
                  <td>{parcela.quantiaPaga?.toLocaleString("pt-Br")}CVE</td>
                  <td>
                    {parcela.dataPagamento
                      ? new Date(parcela.dataPagamento).toLocaleDateString(
                          "pt-PT"
                        )
                      : "N/A"}
                  </td>
                  <td>{parcela.metodoPagamento || "N/A"}</td>
                  <td>
                    <div className="dfe-status">
                      <span className="badge badge-dfe badge-fre">FRE / TVE</span>
                      {parcela.dfePendente === "erro" && (
                        <span className="badge badge-dfe badge-erro">⚠ Erro na emissão</span>
                      )}
                    </div>
                  </td>
                </tr>
              ));
            });
          })}
        </tbody>
      </table>
    </div>
  );
}

export default TabelaContasCorrentes;
